import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserInfo, updateUser } from "../../common/api/apiCalls";
import { useAlert } from "../../common/contexts/AlertContext";
import GenericForm, { FormField } from "../../components/GenericForm";
import { useCallback, useEffect, useState } from "react";
import { useUser } from "../../common/contexts/UserContext";
import { User } from "../../common/types/user";
import { roles } from "../../common/types/roles";
const EditProfile = () => {
  const { user, setUser, fetchUser } = useUser();
  console.log("current:", user);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const alert = useAlert();

  // Define the form fields and set initial values based on the user data
  const buildFields = useCallback(
    (user: User | null | undefined): FormField[] => {
      return [
        {
          label: "First Name",
          name: "firstName",
          type: "text",
          initialValue: user?.firstName || "",
        },
        {
          label: "Last Name",
          name: "lastName",
          type: "text",
          initialValue: user?.lastName || "",
        },
        {
          label: "ID Number",
          name: "idNumber",
          type: "text",
          initialValue: user?.identityNumber || "",
        },
        {
          label: "Position",
          name: "role",
          type: "select",
          options: [],
          disabled: true,
          initialValue: user?.role,
        },
        {
          label: "Phone Number",
          name: "phoneNumber",
          type: "phoneInput",
          initialValue: user?.phoneNumber || "",
        },
        {
          label: "Email",
          name: "username",
          type: "email",
          initialValue: user?.username || "",
          disabled: true,
        },
        { label: "Settings", name: "contactSection", type: "section" },
        {
          label: "Language",
          name: "language",
          type: "select",
          options: [{ label: "English", value: "English" }],
          initialValue: user?.language || "English",
        },
        {
          label: "System Notification",
          name: "systemNotification",
          type: "switch",
          initialValue: user?.systemNotification,
        },
        {
          label: "Email Notification",
          name: "emailNotification",
          type: "switch",
          initialValue: user?.emailNotification,
        },
        {
          label: "Reset Password",
          name: "resetPassword",
          type: "link",
          onClick: () => navigate("/ForgotPassword"),
        },
      ];
    },
    [navigate]
  );
  // Initialize the form fields with user data
  const [fields, setFields] = useState<FormField[]>(buildFields(user));
  useEffect(() => {
    setFields(buildFields(user));
  }, [user, buildFields]);
  const getText = (text: string) => t(`CreateUser.${text}`);

  const handleSubmit = async (formData: { [key: string]: any }) => {
    const res = await updateUser({
      username: formData.username,
      firstName: formData.firstName,
      lastName: formData.lastName,
      identityNumber: formData.idNumber,
      role: formData.role,
      phoneNumber: formData.phoneNumber,
      systemNotification: formData.systemNotification,
      emailNotification: formData.emailNotification,
      language: formData.language,
    });
    if (res.success) {
      const updatedUser = await getUserInfo();
      setUser(updatedUser);
      alert("Success", "msg");
      navigate(-1);
    } else {
      alert(res.err, "error");
    }
  };

  return (
    <>
      <GenericForm
        backButtonAction={() => navigate(-1)}
        backButtonText={getText("Back")}
        buttonText={getText("Save_changes")}
        fields={fields}
        onSubmit={handleSubmit}
        title={getText("edit_Profile")}
      />
    </>
  );
};

export default EditProfile;
